// extracted by mini-css-extract-plugin
export default {"container":"Main_container__gxqrB","leftContainer":"Main_leftContainer__GaOC8","rightContainer":"Main_rightContainer__tRM2m","btnContainer":"Main_btnContainer__7Bby8"};